import React from 'react';

export const ModalPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { title, size } = specificAttrs || {};
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div style={{
        border: '2px solid #3B82F6',
        borderRadius: '8px',
        padding: '20px',
        background: '#FFFFFF',
        maxWidth: size === 'small' ? '300px' : size === 'large' ? '600px' : '450px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
      }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>{title || 'Modal Title'}</h3>
        <span style={{ fontSize: '20px', cursor: 'pointer', color: '#6B7280' }}>×</span>
      </div>
      <div style={{ fontSize: '14px', color: '#6B7280' }}>
        Modal content goes here
      </div>
      </div>
    </div>
  );
};
